import React from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner } from 'yankees-react-utils';
import VideoSearch from './VideoSearch';
import { Team, Player, useOktaQuery } from '../../data';

const VideoSearchRoutes = ({ location: { search } }) => {
    const initSearchParams = search?.substr(1).split('&').reduce((acc, s) => {
        const [key, value] = s.split('=');
        return (key && value) ? { ...acc, [key]: decodeURIComponent(value) } : acc;
    }, {});

    const { data: Batter, isLoading: isLoadingBatter } = useOktaQuery(
        ['player', initSearchParams.BatterID],
        (t) => Player.get(t, { playerId: initSearchParams.BatterID }),
        { enabled: !!initSearchParams.BatterID },
    );
    const { data: Pitcher, isLoading: isLoadingPitcher } = useOktaQuery(
        ['player', initSearchParams.PitcherID],
        (t) => Player.get(t, { playerId: initSearchParams.PitcherID }),
        { enabled: !!initSearchParams.PitcherID },
    );
    const { data: BattingTeam, isLoading: isLoadingBattingTeam } = useOktaQuery(
        ['team', initSearchParams.BattingTeamID],
        (t) => Team.get(t, initSearchParams.BattingTeamID),
        { enabled: !!initSearchParams.BattingTeamID },
    );
    const { data: PitchingTeam, isLoading: isLoadingPitchingTeam } = useOktaQuery(
        ['team', initSearchParams.PitchingTeamID],
        (t) => Team.get(t, initSearchParams.PitchingTeamID),
        { enabled: !!initSearchParams.PitchingTeamID },
    );

    if (isLoadingBatter || isLoadingPitcher || isLoadingBattingTeam || isLoadingPitchingTeam) {
        return <LoadingSpinner />;
    }
    return <VideoSearch initSearch={{ ...initSearchParams, Batter, Pitcher, BattingTeam, PitchingTeam }} />;
};

VideoSearchRoutes.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string,
    }).isRequired,
};

export default VideoSearchRoutes;
